import { matchPath } from "react-router-dom";
import { ORG_SEGMENT, PATHS } from "@constants/Paths";
/**
 * Maps each route to a stable, human-readable name used as the `routeName`
 * property on page-view events. Keep these in sync with `PATHS`.
 */
const ROUTE_NAMES = {
    [PATHS.LANDING]: "landing",
    [PATHS.REPORT_TYPE]: "report-type",
    [PATHS.CHECKOUT]: "checkout",
    [PATHS.LOGIN]: "login",
    [PATHS.DEMO]: "demo",
    [PATHS.FORGOT_PASSWORD]: "forgot-password",
    [PATHS.RESET_PASSWORD]: "reset-password",
    [PATHS.LOGIN_ERROR]: "login-error",
    [PATHS.AUTH_ERROR]: "auth-error",
    [PATHS.HOME]: "home",
    [PATHS.OVERVIEW]: "overview",
    [PATHS.RESULTS]: "results",
    [PATHS.ADMIN_DASHBOARD]: "admin-dashboard",
    [PATHS.TERMS_CONDITIONS_AGREEMENT]: "terms-conditions-agreement",
    [PATHS.COMMUNITY]: "community",
    [PATHS.NEW_REPORT]: "new-report",
    [PATHS.REPORT_SETTINGS]: "report-settings",
    [PATHS.INVALID_TOKEN]: "invalid-token",
};
/**
 * Member routes now scoped under `/o/:orgId` (see the navigation sweep in Routes.tsx /
 * ActiveOrgLayout). A page view against the org-prefixed URL must still resolve to the same
 * routeName as its legacy unprefixed form, or every member page view reports "unknown".
 */
const ORG_SCOPED_PATTERNS = new Set([
    PATHS.HOME,
    PATHS.OVERVIEW,
    PATHS.COMMUNITY,
    PATHS.NEW_REPORT,
    PATHS.REPORT_SETTINGS,
    PATHS.REPORT_TYPE,
    PATHS.CHECKOUT,
]);
/**
 * Resolves a concrete pathname to its route template, name, and params.
 * `matchPath` is exact by default in React Router v6, so more specific routes
 * (e.g. `/login/login-error`) never collide with their prefixes (`/login`).
 * Unknown paths (e.g. 404s) resolve to `routeName: "unknown"`.
 */
export const resolveRoute = (pathname) => {
    for (const pattern of Object.keys(ROUTE_NAMES)) {
        if (ORG_SCOPED_PATTERNS.has(pattern)) {
            const orgMatch = matchPath(`${ORG_SEGMENT}${pattern}`, pathname);
            if (orgMatch) {
                return { path: pattern, routeName: ROUTE_NAMES[pattern], params: orgMatch.params };
            }
        }
        const match = matchPath(pattern, pathname);
        if (match) {
            return { path: pattern, routeName: ROUTE_NAMES[pattern], params: match.params };
        }
    }
    return { path: pathname, routeName: "unknown", params: {} };
};
